import { Urls } from '../../../Shared/Api';

export default class ReviewsCarouselService {
    static getReviews() {
        return fetch(Urls.reviews.getYelpReviewData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/YelpReviews/YelpReviewsCarousel/YelpReviewsCarouselService.js